import React from 'react'
import ScreenWrapper from '~/components/screen_wrappers/screen_wrapper'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import useResourceAuthorization from '@verzekeringapp-mono/shared/src/hooks/use_resource_authorization'

const AddCombiPolicyScreen: React.FC = () => {
  const navigate = useNavigate()

  const [openInfo, setOpenInfo] = React.useState<string[]>([])

  const {
    register,
    handleSubmit,
    formState: { isValid }
  } = useForm({
    defaultValues: {
      relationNumber: '',
      combiPolicyNumber: '',
      email: ''
    },
    mode: 'onChange'
  })

  const { addResourceAuthorization } = useResourceAuthorization()

  const onSubmit = async (combiPolicyNumber: string, email: string) => {
    try {
      await addResourceAuthorization(Number.parseFloat(combiPolicyNumber), email)

      window.alert(
        'Er wordt een bevestigingsmail verstuurd naar het opgegeven e-mailadres (check ook spam). Na “akkoord” gegeven in deze e-mail, zal de combipolis na één dag zichtbaar zijn in je account.'
      )
      navigate('/mijn-profiel')
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      window.alert(
        error?.response?.data?.message ||
        'Er is iets misgegaan bij het toevoegen van de combipolis. Probeer het later opnieuw.'
      )
    }
  }

  return (
    <ScreenWrapper>
      <div className='min-h-full w-full rounded bg-surface-page p-8'>
        <p className='subtitle mb-4'>Combipolis toevoegen</p>

        <form
          className='flex flex-col gap-8 w-1/2'
          onSubmit={handleSubmit(data =>
            onSubmit(data.combiPolicyNumber || '', data.email || '')
          )}
        >
          <div>
            <label
              htmlFor='combiPolicyNumber'
              className='label mt-4 cursor-pointer flex justify-center flex-col w-fit'
              onClick={() =>
                setOpenInfo(prev =>
                  prev.includes('combiPolicyNumber')
                    ? prev.filter(item => item !== 'combiPolicyNumber')
                    : [...prev, 'combiPolicyNumber']
                )
              }
            >
              <span>
                Combipolisnummer &nbsp;
                <FontAwesomeIcon
                  icon={'info-circle'}
                  className='text-icon-muted'
                />
              </span>

              {openInfo.includes('combiPolicyNumber') && (
                <div className='my-2 rounded-lg bg-surface-info p-4 font-light text-text-secondary'>
                  Het combipolisnummer vind je bovenaan je polisblad of kun je
                  opvragen bij je verzekeringsadviseur.
                </div>
              )}
            </label>

            <input
              className='textfield mt-2'
              type='text'
              id='combiPolicyNumber'
              {...register('combiPolicyNumber', { required: true })}
            />
          </div>

          <div>
            <label
              htmlFor='email'
              className='label mt-4 cursor-pointer flex justify-center flex-col w-fit'
              onClick={() =>
                setOpenInfo(prev =>
                  prev.includes('email')
                    ? prev.filter(item => item !== 'email')
                    : [...prev, 'email']
                )
              }
            >
              <span>
                E-mailadres &nbsp;
                <FontAwesomeIcon
                  icon={'info-circle'}
                  className='text-icon-muted'
                />
              </span>

              {openInfo.includes('email') && (
                <div className='my-2 rounded-lg bg-surface-info p-4 font-light text-text-secondary'>
                  Het e-mailadres dat is gekoppeld aan het combipolisnummer. Op
                  dit e-mailadres ontvang je een verificatiemail.
                </div>
              )}
            </label>

            <input
              className='textfield mt-2'
              type='email'
              id='email'
              {...register('email', { required: true })}
            />
          </div>

          <button
            type='submit'
            disabled={!isValid}
            className={`w-full rounded-md bg-action-primary-background text-action-primary-foreground ${
              isValid ? '' : 'opacity-50 cursor-not-allowed'
            } hover:bg-opacity-80`}
          >
            <p className='py-4 text-action-primary-foreground'>Verifiëren</p>
          </button>
        </form>
      </div>
    </ScreenWrapper>
  )
}

export default AddCombiPolicyScreen
